import { render, staticRenderFns } from "./vClickModal.vue?vue&type=template&id=7b85ee06&"
import script from "./vClickModal.vue?vue&type=script&lang=js&"
export * from "./vClickModal.vue?vue&type=script&lang=js&"
import style0 from "./vClickModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports